<template>
  <div>
    <v-layout style=" margin-top: 25px;">
      <span class="labelTip"><b>Selecciona tipo de comunicado</b></span>
    </v-layout>
    <v-item-group>
      <v-item>
        <v-btn
          round
          :disabled="!enabled || isEdit"
          :class="type == 'E' ? 'primary': 'outline'"
          style="text-transform: capitalize !important; font-size:10px !important;"
          @click="changeType('E')"
        >
          Evento
        </v-btn>
      </v-item>
      <v-item>
        <v-btn
          round
          :disabled="!enabled || isEdit"
          :class="(type == 'A' || type == 'R') ? 'primary': 'outline'"
          style="text-transform: capitalize !important; font-size:10px !important;"
          @click="changeType('A')"
        >
          Aviso
        </v-btn>
      </v-item>
    </v-item-group>
    <v-layout
      wrap
      row
    >
      <v-flex
        xs6
        md6
        v-show="type != 'E'"
      >
        <v-checkbox
          class="md6"
          color="primary"
          v-model="confirmParent"
          style="margin-left:15px"
          @change="confirmParentChange"
          :disabled="!enabled || isEdit"
        >
          <template v-slot:label>
            Confirmación del tutor
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  color="black"
                  dark
                  v-on="on"
                >
                  help
                </v-icon>
              </template>
              <span>Para requerir que el tutor indique que está enterado del comunicado</span>
            </v-tooltip>
          </template>
        </v-checkbox>
      </v-flex>
      <!-- asistencia -->
      <v-flex
        xs6
        md6
        v-show="type == 'E'"
        class="mt-2"
      >
        <span class="labelTip md4"><b>Asistencia</b>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                x-small
                color="black"
                dark
                v-on="on"
              >help</v-icon>
            </template>
            <span>Para requerir asistencia del tutor y/o el alumno</span>
          </v-tooltip>
        </span>
        <div style="">
          <v-checkbox
            class="md4"
            color="primary"
            :disabled="!enabled || isEdit"
            v-model="assistanceRequired"
            @change="assistanceRequiredChange"
            style="margin-left:10px; display: inline-block"
            :error-messages="assitenceError"
          >
            <template v-slot:label>
              Tutor   
            </template>
          </v-checkbox>
          <v-checkbox
            class="md4"
            color="primary"
            :disabled="!enabled || isEdit"
            v-model="attendanceStudentRequired"
            @change="attendanceStudentRequiredChange"
            style="margin-left:10px; display: inline-block"
            :error-messages="assitenceError"
          >
            <template v-slot:label>
              Alumno   
            </template>
          </v-checkbox>
        </div>
        <div
          class="mError"
          v-if="assitenceErrorWithText.length != 0"
        >
          {{ assitenceErrorWithText[0] }}          
        </div>
      </v-flex>
    </v-layout>
    <v-layout
      wrap
      row
      v-show="type == 'E' && showDatePicker && enabled"
    >
      <v-flex>
        <VueTimePickerTool
          :disabledV="!startDate || !endDate"
          :error-messages="errorMessage"
          tooltip="Es necesario seleccionar la fecha de inicio y final primero"
          :min="getMinDate"
          :max="getMaxDate"
          title-date="Fecha de inicio evento"
          title-time="Hora de inicio"
          v-model="startEventDate"
          location="up"
          style="margin-top:15px;"
          @change="startEventDateChange"
        />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import { isEmptyOrNull } from '../../plugins/GeneralMethods';
import VueTimePickerTool from "../Sections/Notices/Tools/VueDateTimePicker2";

export default {
   components: {
    VueTimePickerTool
  },
    props: {
        v: {},
        type: {
          type: String,
          default: 'E',
        },
        assistanceRequired: {
          type: Boolean,
          default: false
        },
        attendanceStudentRequired: {
          type: Boolean,
          default: false
        },
        confirmParent: {
          type: Boolean,
          default: false
        },
        startEventDate: {
          type: String,
          default: '',
        },
        startDate: {
          type: String,
          default: '',
        },
        endDate: {
          type: String,
          default: '',
        },
        showDatePicker: {
          type: Boolean,
          default: true
        },
        enabled: {
          type: Boolean,
          default: true
        },
        isEdit:{
          type: Boolean,
          default: false
        },
        errorMessage: {
          type: String,
          default: ''
        }
    },
    methods: {
        changeType(type){
          this.$emit("type-selected", type)
        },
        confirmParentChange(){
          this.$emit("confirm-parent-change", this.confirmParent)
        },
        assistanceRequiredChange(){
          this.$emit("assistence-requiered-change", this.assistanceRequired)
        },
        attendanceStudentRequiredChange(){
          this.$emit("attendance-student-required-change", this.attendanceStudentRequired)
        },
        startEventDateChange(){
          if (this.enabled) {
           this.$emit("start-event-date-change", this.startEventDate) 
          }
        }
    },
    computed: {
      getMinDate(){
         if(this.startDate){
          const date = new Date(this.startDate).toLocaleDateString("sv-SE"); 
          return date
        }
        return ""
      },
      getMaxDate(){
        if(this.endDate){
          const date = new Date(this.endDate).toLocaleDateString("sv-SE"); 
          return date
        }
        return ""
      },
      assitenceErrorWithText() {
				const errors = [];
        if(isEmptyOrNull(this.v) || isEmptyOrNull(this.v.assistanceRequired)){
          return errors
        }
        if (!this.v.assistanceRequired.$dirty){
          return errors
        }
        if (this.v.assistanceRequired.$invalid && this.v.attendanceStudentRequired.$invalid) {
          errors.push("Es necesario seleccionar por lo menos un tipo de asistencia");
        }
				return errors;
      },
      assitenceError() {
			const errors = [];
        if(isEmptyOrNull(this.v) || isEmptyOrNull(this.v.assistanceRequired)){
          return errors
        }
        if (!this.v.assistanceRequired.$dirty){
          return errors
        }
        if (this.v.assistanceRequired.$invalid && this.v.attendanceStudentRequired.$invalid) {
          errors.push("");
        }
				return errors;
      },
    }
}

</script>
<style>

.mError {
  color: red;
}

.m-title {
  text-transform: capitalize !important;
  font-size:10px !important;
}

.m-title.active {
  text-transform: capitalize !important;
  font-size:10px !important;
}
</style>
